import React from 'react';
import Tbodyinvoice from "components/table/components/tbodyinvoice";
import ScrollableTableWrapper from "components/table/components/ScrollableTableWrapper";

const getWidthClass = (index) => {
    if (index === 0) return 'pl-4 pr-2 min-w-[150px]'; // Mois
    if (index === 1) return 'px-2 min-w-[120px]'; // Montant
    if (index === 2) return 'px-2 min-w-[100px]'; // État
    if (index === 3) return 'px-2 min-w-[120px]'; // Date
    return 'px-2';
};

const Tableinvoice = ({champsHeader, champsBody, isWaiting}) => {
    return (
        <ScrollableTableWrapper className="overflow-y-visible w-full">
            <table className="jbz-table table-auto w-full min-w-[800px] text-gray-500 space-y-6 ft-sm">
                <thead className="sticky top-0 z-10">
                    <tr className="sticky top-0 z-10">
                        {champsHeader?.map((item, index) => (
                            <th
                                key={index}
                                className={`sticky top-0 z-10 bg-gray-50 border-b border-gray-100 whitespace-nowrap ${getWidthClass(index)} py-3.5 text-left text-sm font-medium text-gray-700`}
                            >
                                {item.toUpperCase()}
                            </th>
                        ))}
                        <th className="sticky top-0 z-10 bg-gray-50 border-b border-gray-100 py-3.5 pl-2 pr-3 min-w-[100px]"></th>
                    </tr>
                </thead>
                <tbody className={isWaiting ? 'animate-pulse' : undefined}>
                {
                    isWaiting ? (
                        <>
                            {[1, 2, 3, 4, 5].map((i, index) => (
                                <tr key={index}>
                                    {/* Mois */}
                                    <td className="py-5 pl-4 pr-2 min-w-[150px]">
                                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    </td>
                                    {/* Montant */}
                                    <td className="py-5 px-2 min-w-[120px]">
                                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                                    </td>
                                    {/* État */}
                                    <td className="py-5 px-2 min-w-[100px]">
                                        <div className="h-6 bg-gray-200 rounded w-20"></div>
                                    </td>
                                    {/* Date */}
                                    <td className="py-5 px-2 min-w-[120px]">
                                        <div className="h-4 bg-gray-200 rounded w-24"></div>
                                    </td>
                                    {/* Action */}
                                    <td className="py-5 pl-2 pr-3 min-w-[100px]">
                                        <div className="h-8 w-8 bg-gray-200 rounded"></div>
                                    </td>
                                </tr>
                            ))}
                        </>
                    ) : (
                        <Tbodyinvoice champsBody={champsBody}/>
                    )
                }
                </tbody>
            </table>
        </ScrollableTableWrapper>
    );
};

export default Tableinvoice;